import React, { FC } from 'react';
import { RiskScoresTable } from './RiskScoresTable/RiskScoresTable';
import { RiskScoresTableInfo } from './RiskScoresTable/RiskScoresTableInfo';
import { LoadTrigger } from './LoadTrigger';

interface Props {
  id: string;
}

export const Results: FC<Props> = ({ id }) => {
  const attrId = `${id}Results`;
  return (
    <React.Fragment>
      <div data-testid={attrId} data-cy={attrId} style={{ marginTop: '30px' }}>
        <RiskScoresTableInfo />
        <RiskScoresTable />
      </div>
      <LoadTrigger />
    </React.Fragment>
  );
};
